
import React, { useState, useEffect } from 'react';
import Hero from '../Components/Hero';
import { Shield, Lock, Users, Check, ChevronRight, ArrowRight } from 'lucide-react';
import { Footer } from '../Components/Footer';
import PartnersSlider from '../Components/PartnersSlider ';
import Navbar from '../Components/Navbar';
import SubHeader from '../Components/SubHeader';
import { useTranslation } from '../../TranslationContext';
import { useAdminInfo } from '../../admin/pages/Dashboard/DashboarEntreprise/hooksUseretApplication/hookAdmin Info';

export const Home: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [companyName, setCompanyName] = useState<string>('');
  const { t } = useTranslation();
  const { adminInfo, isLoading } = useAdminInfo();


  useEffect(() => {
    const company = localStorage.getItem('company');
    setIsLoggedIn(!!company);
    setCompanyName(company || '');
  }, []);
  const displayName = () => {
    if (isLoading) return 'Chargement...';
    if (adminInfo?.fullName && adminInfo.fullName.trim() !== '') {
      return adminInfo.fullName;
    }
    return adminInfo?.email || 'Utilisateur';
  };


  const handleRequestDemo = () => {
    window.location.href = '/support';
  };

  const handleReadArticles = () => {
    window.location.href = '/articles';
  };

  const navigateTo = (path: string) => {
    window.location.href = path;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('/background1.jpg')" }}>
        <Navbar />
        <SubHeader isDarkMode={false} />
        
        {/* Conditional Hero Section */}
        {isLoggedIn ? (
          <div className="relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-[#2C3E50] to-[#4A5568] opacity-90" />
            <div className="mx-auto max-w-7xl relative z-10">
              <div className="px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8 text-center">
                <div className="animate-fade-in-up">
                  <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl mb-6">
                    <span className="block text-white">{t('welcome')}</span>
                    <span className="block text-[#F3DAB3]"> {displayName()} _{companyName}</span>
                   
                  </h1>
                  <p className="mx-auto mt-6 max-w-lg text-center text-xl text-white sm:max-w-3xl">
                    {t('welcome_back')}
                  </p>
                  <div className="mt-10">
                    <button 
                      className="px-8 py-3 bg-[#F3DAB3] text-[#2C3E50] rounded-lg font-medium transition-all duration-300 hover:bg-[#DBC090] hover:shadow-lg flex items-center mx-auto"
                      onClick={() => navigateTo('/EntrepriseDashboard')}
                    >
                      {t('go_to_dashboard')}
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
         <div></div>
        )}
      </div>
      
      {/* Secure Authenticator Section */}
      <div className="bg-gradient-to-b from-white to-[#DDE6F1] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 transform transition-all duration-500 hover:scale-105">
            <h2 className="text-3xl font-bold text-[#2C3E50]">
              {t('welcome_to_secure_authenticator')}
            </h2>
            <div className="h-1 w-24 bg-[#F3DAB3] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-[#F3DAB3] to-[#F8E6CA] p-8 rounded-xl shadow-md border border-[#F3DAB3]/30 transition-all duration-300 hover:shadow-xl group">
              <h3 className="text-xl font-semibold mb-6 text-[#2C3E50] group-hover:text-[#1A2533]">
                {t('authentication_authorization')}
              </h3>
              <ul className="space-y-5">
                {[
                  t('safely_use_otenti'),
                  t('define_access_level'),
                  t('identify_inactive_users'),
                  t('identify_abused_authentications')
                ].map((text, index) => (
                  <li key={index} className="flex items-start group">
                    <div className="bg-white p-1 rounded-full mr-3 shadow-sm group-hover:bg-[#2C3E50] transition-colors duration-300">
                      <Check className="h-5 w-5 text-[#2C3E50] group-hover:text-white" />
                    </div>
                    <span className="text-[#2C3E50]">{text}</span>
                  </li>
                ))}
              </ul>
              <button 
                className="mt-8 px-6 py-2 bg-[#2C3E50] text-white rounded-lg hover:bg-[#1A2533] transition-all duration-300 flex items-center"
                onClick={() => navigateTo('/About')}
              >
                {t('learn_more')}
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 transition-all duration-300 hover:shadow-xl group">
              <h3 className="text-xl font-semibold mb-6 text-[#2C3E50] group-hover:text-[#1A2533]">
                {t('optimize_costs_mitigate_losses')}
              </h3>
              <ul className="space-y-5">
                {[
                  t('one_password_for_all'),
                  t('rely_on_identity_provider'),
                  t('password_cannot_be_stolen')
                ].map((text, index) => (
                  <li key={index} className="flex items-start group">
                    <div className="bg-[#F3DAB3] p-1 rounded-full mr-3 shadow-sm group-hover:bg-[#2C3E50] transition-colors duration-300">
                      <Check className="h-5 w-5 text-[#2C3E50] group-hover:text-white" />
                    </div>
                    <span className="text-[#2C3E50]">{text}</span>
                  </li>
                ))}
              </ul>
              <button 
                className="mt-8 px-6 py-2 bg-[#2C3E50] text-white rounded-lg hover:bg-[#1A2533] transition-all duration-300 flex items-center"
                onClick={() => navigateTo('/Support')}
              >
                {t('learn_more')}
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Hero />
      {/* Features Section */}
      <div className="py-16 bg-gradient-to-b from-[#2C3E50]/90 to-[#1A2533]/90 relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: "url('/background1.jpg')" }}></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:text-center mb-12">
            <h2 className="text-base text-[#F3DAB3] font-semibold tracking-wide uppercase">
              {t('features_title')}
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
              {t('features_subtitle')}
            </p>
            <div className="h-1 w-24 bg-[#F3DAB3] mx-auto mt-4 rounded-full"></div>
          </div>
          <div className="mt-12">
            <div className="grid grid-cols-1 gap-y-10 md:grid-cols-2 lg:grid-cols-3 md:gap-x-8 md:gap-y-10">
              {[
                // { name: t('auth'), description: t('auth_desc'), icon: Shield, link: '/auth-features' },
                // { name: t('users'), description: t('users_desc'), icon: Users, link: '/user-features' },
                // { name: t('security'), description: t('security_desc'), icon: Lock, link: '/security-features' },
                { name: t('auth'), description: t('auth_desc'), icon: Shield, link: '/About' },
                { name: t('users'), description: t('users_desc'), icon: Users, link: '/About' },
                { name: t('security'), description: t('security_desc'), icon: Lock, link: '/About' },

              ].map((feature) => (
                <div key={feature.name} className="relative flex flex-col items-start p-8 border border-[#F3DAB3]/20 rounded-xl shadow-md bg-white/10 backdrop-blur-sm transition-all duration-300 hover:shadow-xl hover:bg-white/20 group">
                  <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#F3DAB3] text-[#2C3E50] group-hover:bg-white transition-all duration-300 mb-5">
                    <feature.icon className="h-7 w-7" aria-hidden="true" />
                  </div>
                  <p className="text-xl leading-6 font-bold text-white mb-3">{feature.name}</p>
                  <p className="text-gray-300 mb-6">{feature.description}</p>
                  <button 
                    className="mt-auto px-5 py-2 bg-transparent border border-[#F3DAB3] text-[#F3DAB3] rounded-lg group-hover:bg-[#F3DAB3] group-hover:text-[#2C3E50] transition-all duration-300 flex items-center text-sm font-medium"
                    onClick={() => navigateTo(feature.link)}
                  >
                    {t('learn_more')}
                    <ChevronRight className="ml-1 h-4 w-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Digital DNA Section */}
      <div className="bg-[#DDE6F1] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6 order-2 md:order-1">
              <h3 className="text-2xl font-bold text-[#2C3E50] mb-6">{t('digital_in_dna')}</h3>
              <p className="text-[#2C3E50] leading-relaxed">
                {t('digital_in_dna_description')}
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 pt-4">
                <button 
                  onClick={handleReadArticles}
                  className="px-6 py-3 bg-[#2C3E50] text-white rounded-lg hover:bg-slate-800 transition-all duration-300 shadow-sm hover:shadow-md flex items-center justify-center"
                >
                  {t('read_our_articles')}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button 
                  onClick={handleRequestDemo}
                  className="px-6 py-3 border-2 border-[#2C3E50] text-[#2C3E50] rounded-lg hover:bg-[#2C3E50] hover:text-white transition-all duration-300 shadow-sm hover:shadow-md flex items-center justify-center"
                >
                  {t('request_a_demo')}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="bg-white p-8 rounded-xl shadow-lg transform transition-all duration-500 hover:scale-105">
                <div className="h-48 bg-gradient-to-r from-[#2C3E50] to-[#4A5568] rounded-lg mb-6 flex items-center justify-center">
                  <Shield className="h-16 w-16 text-[#F3DAB3]" />
                </div>
                <h4 className="text-xl font-semibold text-[#2C3E50] mb-4">{t('cybersecurity_excellence')}</h4>
                <p className="text-gray-600">
                  {t('cybersecurity_excellence_description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Partners Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-center text-[#2C3E50] mb-12">
            {t('our_trusted_partners')}
          </h2>
          <PartnersSlider />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Home;

// import React, { useState, useEffect } from 'react';
// import Hero from '../Components/Hero';
// import { Shield, Lock, Users, Check, ChevronRight, ArrowRight } from 'lucide-react';
// import { Footer } from '../Components/Footer';
// import PartnersSlider from '../Components/PartnersSlider ';
// import Navbar from '../Components/Navbar';
// import SubHeader from '../Components/SubHeader';
// import { useTranslation } from '../../TranslationContext';

// export const Home: React.FC = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
//   const [companyName, setCompanyName] = useState<string>('');
//   const { t } = useTranslation();

//   useEffect(() => {
//     const company = localStorage.getItem('company');
//     setIsLoggedIn(!!company);
//     setCompanyName(company || '');
//   }, []);

//   const handleRequestDemo = () => {
//     window.location.href = '/request-demo';
//   };

//   const handleReadArticles = () => {
//     window.location.href = '/articles';
//   };

//   const navigateTo = (path: string) => {
//     window.location.href = path;
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Hero Section */}
//       <div className="bg-cover bg-center bg-fixed" style={{ backgroundImage: "url('/background1.jpg')" }}>
//         <Navbar />
//         <SubHeader isDarkMode={false} />
        
//         {/* Conditional Hero Section */}
//         {isLoggedIn ? (
//           <div className="relative overflow-hidden">
//             <div className="absolute inset-0 bg-gradient-to-r from-[#2C3E50] to-[#4A5568] opacity-90" />
//             <div className="mx-auto max-w-7xl relative z-10">
//               <div className="px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8 text-center">
//                 <div className="animate-fade-in-up">
//                   <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl mb-6">
//                     <span className="block text-white">{t('home.welcome')}</span>
//                     <span className="block text-[#F3DAB3]">{companyName}</span>
//                   </h1>
//                   <p className="mx-auto mt-6 max-w-lg text-center text-xl text-white sm:max-w-3xl">
//                     {t('home.welcome_back')}
//                   </p>
//                   <div className="mt-10">
//                     <button 
//                       className="px-8 py-3 bg-[#F3DAB3] text-[#2C3E50] rounded-lg font-medium transition-all duration-300 hover:bg-[#DBC090] hover:shadow-lg flex items-center mx-auto"
//                       onClick={() => navigateTo('/dashboard')}
//                     >
//                       Go to Dashboard
//                       <ArrowRight className="ml-2 h-5 w-5" />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div></div>
//           // <Hero />
//         )}
//       </div>
      
     
//       {/* Secure Authenticator Section */}
//       <div className="bg-gradient-to-b from-white to-[#DDE6F1] py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12 transform transition-all duration-500 hover:scale-105">
//             <h2 className="text-3xl font-bold text-[#2C3E50]">
//               Welcome to a more secure authenticator
//             </h2>
//             <div className="h-1 w-24 bg-[#F3DAB3] mx-auto mt-4 rounded-full"></div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             <div className="bg-gradient-to-br from-[#F3DAB3] to-[#F8E6CA] p-8 rounded-xl shadow-md border border-[#F3DAB3]/30 transition-all duration-300 hover:shadow-xl group">
//               <h3 className="text-xl font-semibold mb-6 text-[#2C3E50] group-hover:text-[#1A2533]">Authentication & Authorization</h3>
//               <ul className="space-y-5">
//                 {[
//                   'Safely use Otenti as your identity provider',
//                   'Define level of access to your application',
//                   'Easily identified inactive users',
//                   'Easily identified abused authentications'
//                 ].map((text, index) => (
//                   <li key={index} className="flex items-start group">
//                     <div className="bg-white p-1 rounded-full mr-3 shadow-sm group-hover:bg-[#2C3E50] transition-colors duration-300">
//                       <Check className="h-5 w-5 text-[#2C3E50] group-hover:text-white" />
//                     </div>
//                     <span className="text-[#2C3E50]">{text}</span>
//                   </li>
//                 ))}
//               </ul>
//               <button 
//                 className="mt-8 px-6 py-2 bg-[#2C3E50] text-white rounded-lg hover:bg-[#1A2533] transition-all duration-300 flex items-center"
//                 onClick={() => navigateTo('/authentication')}
//               >
//                 Learn more
//                 <ChevronRight className="ml-2 h-4 w-4" />
//               </button>
//             </div>
            
//             <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 transition-all duration-300 hover:shadow-xl group">
//               <h3 className="text-xl font-semibold mb-6 text-[#2C3E50] group-hover:text-[#1A2533]">Optimize Costs & Mitigate losses</h3>
//               <ul className="space-y-5">
//                 {[
//                   'You safely can use only one password for all the software you have to access',
//                   'Rely on an Identity Provider fully built & maintained for you',
//                   "Your password can't be stolen"
//                 ].map((text, index) => (
//                   <li key={index} className="flex items-start group">
//                     <div className="bg-[#F3DAB3] p-1 rounded-full mr-3 shadow-sm group-hover:bg-[#2C3E50] transition-colors duration-300">
//                       <Check className="h-5 w-5 text-[#2C3E50] group-hover:text-white" />
//                     </div>
//                     <span className="text-[#2C3E50]">{text}</span>
//                   </li>
//                 ))}
//               </ul>
//               <button 
//                 className="mt-8 px-6 py-2 bg-[#2C3E50] text-white rounded-lg hover:bg-[#1A2533] transition-all duration-300 flex items-center"
//                 onClick={() => navigateTo('/optimization')}
//               >
//                 Learn more
//                 <ChevronRight className="ml-2 h-4 w-4" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Hero />
//       {/* Features Section */}
//       <div className="py-16 bg-gradient-to-b from-[#2C3E50]/90 to-[#1A2533]/90 relative overflow-hidden">
//         <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{ backgroundImage: "url('/background1.jpg')" }}></div>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//           <div className="lg:text-center mb-12">
//             <h2 className="text-base text-[#F3DAB3] font-semibold tracking-wide uppercase">
//               {t('home.features_title')}
//             </h2>
//             <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
//               {t('home.features_subtitle')}
//             </p>
//             <div className="h-1 w-24 bg-[#F3DAB3] mx-auto mt-4 rounded-full"></div>
//           </div>
//           <div className="mt-12">
//             <div className="grid grid-cols-1 gap-y-10 md:grid-cols-2 lg:grid-cols-3 md:gap-x-8 md:gap-y-10">
//               {[
//                 { name: t('auth.name'), description: t('home.features.auth.description'), icon: Shield, link: '/auth-features' },
//                 { name: t('users.name'), description: t('home.features.users.description'), icon: Users, link: '/user-features' },
//                 { name: t('security.name'), description: t('home.features.security.description'), icon: Lock, link: '/security-features' },
//               ].map((feature) => (
//                 <div key={feature.name} className="relative flex flex-col items-start p-8 border border-[#F3DAB3]/20 rounded-xl shadow-md bg-white/10 backdrop-blur-sm transition-all duration-300 hover:shadow-xl hover:bg-white/20 group">
//                   <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#F3DAB3] text-[#2C3E50] group-hover:bg-white transition-all duration-300 mb-5">
//                     <feature.icon className="h-7 w-7" aria-hidden="true" />
//                   </div>
//                   <p className="text-xl leading-6 font-bold text-white mb-3">{feature.name}</p>
//                   <p className="text-gray-300 mb-6">{feature.description}</p>
//                   <button 
//                     className="mt-auto px-5 py-2 bg-transparent border border-[#F3DAB3] text-[#F3DAB3] rounded-lg group-hover:bg-[#F3DAB3] group-hover:text-[#2C3E50] transition-all duration-300 flex items-center text-sm font-medium"
//                     onClick={() => navigateTo(feature.link)}
//                   >
//                     Learn more
//                     <ChevronRight className="ml-1 h-4 w-4" />
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Digital DNA Section */}
//       <div className="bg-[#DDE6F1] py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
//             <div className="space-y-6 order-2 md:order-1">
//               <h3 className="text-2xl font-bold text-[#2C3E50] mb-6">Digital in DNA</h3>
//               <p className="text-[#2C3E50] leading-relaxed">
//                 We're an innovative start-up with Cybersecurity challenges in
//                 heart of our DNA. Today, we are offering a panel of services to
//                 any clients in order to help them to improve the security of their
//                 data, and thus making them more compliant to
//                 national/international security regulations like ISO, NIS, NIS2,
//                 ISAE, etc.
//               </p>
//               <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 pt-4">
//                 <button 
//                   onClick={handleReadArticles}
//                   className="px-6 py-3 bg-[#2C3E50] text-white rounded-lg hover:bg-slate-800 transition-all duration-300 shadow-sm hover:shadow-md flex items-center justify-center"
//                 >
//                   Read our articles
//                   <ArrowRight className="ml-2 h-5 w-5" />
//                 </button>
//                 <button 
//                   onClick={handleRequestDemo}
//                   className="px-6 py-3 border-2 border-[#2C3E50] text-[#2C3E50] rounded-lg hover:bg-[#2C3E50] hover:text-white transition-all duration-300 shadow-sm hover:shadow-md flex items-center justify-center"
//                 >
//                   Request a Demo
//                   <ArrowRight className="ml-2 h-5 w-5" />
//                 </button>
//               </div>
//             </div>
//             <div className="order-1 md:order-2">
//               <div className="bg-white p-8 rounded-xl shadow-lg transform transition-all duration-500 hover:scale-105">
//                 <div className="h-48 bg-gradient-to-r from-[#2C3E50] to-[#4A5568] rounded-lg mb-6 flex items-center justify-center">
//                   <Shield className="h-16 w-16 text-[#F3DAB3]" />
//                 </div>
//                 <h4 className="text-xl font-semibold text-[#2C3E50] mb-4">Cybersecurity Excellence</h4>
//                 <p className="text-gray-600">
//                   Our expertise helps businesses protect their most valuable digital assets and maintain compliance with evolving security standards.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Partners Section */}
//       <div className="bg-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h2 className="text-2xl font-bold text-center text-[#2C3E50] mb-12">
//             Our Trusted Partners
//           </h2>
//           <PartnersSlider />
//         </div>
//       </div>
      
//       <Footer />
//     </div>
//   );
// };

// export default Home;
